module.exports = __webpack_public_path__ + "img/kids-3.fcdb137c.jpg";